<template>
  <!-- prettier-ignore -->
  <div
class="product"
:data-product-id="productId">
    <div
      class="product__group"
      v-text="$t(`content.groups.${groupId}`).title"
    />

    <ovp-price
      class="product__price"
      :price="options.price"
      :suffix="$t('product.currency')"
    />

    <ovp-typography
      class="product__options"
      tag="span"
      type="body05"
      v-text="productOptions"
    />

    <div
      class="product__name"
      v-text="$t(content).name"
    />

    <div
      class="product__description"
      v-html="$t(content).description"
    />

    <ul class="product-bullets">
      <li
        v-for="(bullet, key) in $t(content).bulletPoints"
        :key="key"
        v-text="bullet"
      />
    </ul>

    <div class="product-actions">
      <span />

      <ovp-button
        primary
        tiny
        :disabled="!isSelected"
        @click="replace"
        v-text="$t('product.actions.add')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { OvpPrice } from '@/components/Product'

import { ProductHelper } from '@/helpers'

export default {
  name: 'OvpProduct',

  components: {
    OvpPrice,
  },

  props: {
    groupId: {
      type: String,
      required: true,
    },

    personId: {
      type: String,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    productId: {
      type: String,
      required: true,
    },

    selected: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      open: false,
    }
  },

  computed: {
    ...mapGetters('products', ['getCategoryIdFromProduct']),

    categoryId() {
      return this.getCategoryIdFromProduct(this.productId)
    },

    content() {
      return `content.products.${this.productId}`
    },

    isSelected() {
      return this.selected === true || (this.selected === null && this.product.selected)
    },

    options() {
      return this.product.prices.find(p => p.selected)
    },

    optionTitles() {
      return ProductHelper.optionTitles(
        this.$te.bind(this),
        this.$t.bind(this),
        this.productId,
        this.groupId,
        this.categoryId
      )
    },

    productOptions() {
      return ProductHelper.composeOptions(this.product, this.categoryId, this.optionTitles, this.$t.bind(this))
    },
  },

  methods: {
    replace() {
      this.$emit('replace')
    },
  },
}
</script>

<style name="mobile" scoped>
.product {
  display: grid;
  height: 100%;
  grid-template-rows:
    minmax(0, auto) /* group */
    50px /* price */
    minmax(0, auto) /* criteria */
    45px /* name */
    minmax(0, auto) /* description */
    1fr /* bullets */
    minmax(0, auto) /* actions */;

  padding: 15px;

  &__group {
    font-weight: bold;
    font-size: 14px;
  }

  &__price {
    font-weight: bold;
    font-size: 36px;
    line-height: 50px;
  }

  &__name {
    font-size: 24px;
    padding: 8px 0 4px 0;
  }

  &__description {
    padding: 0 0 14px 0;
  }

  &-bullets {
    margin: 5px 0 0 0;
    padding: 0 20px 24px 20px;

    li {
      letter-spacing: 0;
      line-height: 20px;
      color: var(--c-black);
    }
  }

  &-actions {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
    align-items: baseline;

    button {
      margin: 0;
    }
  }

  &--selected {
    background-color: var(--c-original-green-lighten-3);
    border-color: var(--c-original-green-lighten-3);
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .product {
    &-actions {
      flex-direction: row;
    }
  }
}
</style>
